import axios from "axios";
import * as types from "../mutation-types";
import api from "@/api/api";

export const state = {
  allSkills: [],
  employeeSkill: []
};

// getters
export const getters = {
  allSkills: state => state.allSkills,
  employeeSkill: state => state.employeeSkill
};

// mutations
export const mutations = {
  [types.SKILLSHEET.GET_ALL_SKILLS](state, allDataSkill) {
    state.allSkills = allDataSkill;
  },
  [types.SKILLSHEET.GET_EMPLOYEE_SKILLS](state, employeeDataSkill) {
    state.employeeSkill = employeeDataSkill;
  }
};

// actions
export const actions = {
  getAllSkills({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: api.GET_LIST_SKILL,
        method: 'GET'
      }).then(response => {
        commit(types.SKILLSHEET.GET_ALL_SKILLS, response.data ? response.data : []);
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    });
  },
  async getEmployeekills({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: api.GET_EMPLOYEE_SKILL,
        method: 'GET'
      }).then(response => {
        commit(types.SKILLSHEET.GET_EMPLOYEE_SKILLS, response.data ? response.data : []);
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    });
  },
  async saveUpdateSkill({ commit }, params) {
    await axios.post(api.POST_EMPLOYEE_SKILL, params);
  },
};
